// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"8637903f","453":"136d3566","934":"f19ea665"}[chunkId] + ".chunk.js";
};